export default __webpack_public_path__ + "static/valid-key-character-f21e4b780c2e51570e86f06310a3fcdc.svg";